module.exports = __webpack_public_path__ + "media/images/mobal-mask-0f76607d9ad4c8a1086fc66935921409.svg";